import { create } from "zustand";
import { TimelineData } from "../Timeline/Types";

interface TimelinesStore {
    setTimeline: (postId: string, timeline: TimelineData) => void;
    timeline:
        | {
              [postId: string]: TimelineData | undefined;
          }
        | undefined;
}

export const useTimelinesStore = create<TimelinesStore>()((set, get) => ({
    timeline: undefined,
    setTimeline: (postId, timelineData) => {
        const previousData = get().timeline ?? {};
        previousData[postId] = timelineData;
        set({
            timeline: previousData,
        });
    },
}));
